const PendingEventStore = () => import(/* webpackChunkName: "UnassignedStore" */ '@/views/PendingEventStore')
const pendingEventStoreRouter = [
  {
    // path: '', 或者 重定向
    path: '/pendingEventStore',
    component: PendingEventStore,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Pending Event Store'
    }
  }
]

export default pendingEventStoreRouter
